import { useState, useEffect } from "react";
import emailjs from "emailjs-com";

// ─── EMAILJS CONFIGURATION ────────────────────────────────────────────────────
// Replace these with your actual EmailJS credentials from https://www.emailjs.com
const EMAILJS_PUBLIC_KEY   = "omGg1UJH-UCtjjD8f";      // Account → API Keys
const EMAILJS_SERVICE_ID   = "service_pnt99op";      // Email Services → Service ID
const EMAILJS_QUOTE_TEMPLATE   = "template_v4sbssd";    // Email Templates → Template ID
const EMAILJS_CONTACT_TEMPLATE = "template_dh5qphn";  // Email Templates → Template ID

// ─── DATA ────────────────────────────────────────────────────────────────────

const NAV_ITEMS = [
  {
    label: "Equipment",
    mega: {
      cols: [
        { title: "Available equipments", links: [["Skid-Steer Loaders","page-equipment"],["Compact Track Loaders","page-equipment"],["Backhoe Loaders","page-equipment"],["View All Loaders","page-equipment"]] },
         ],
    },
  },
 
  {
    label: "Parts & Service",
    mega: {
      cols: [
        { title: "Parts", links: [["Tires & Tracks","page-parts"],["Batteries","page-parts"],["Filters","page-parts"],["Fluids and Lubricants","page-parts"],["Parts Overview","page-parts"]] },
        { title: "Service", links: [["Service Schedules","page-parts"],["Maintenance Videos","page-parts"],["Warranty","page-parts"],["Service Overview","page-parts"]] },
      ],
    },
  },
  {
    label: "Buying Tools",
    mega: {
      cols: [
        { title: "", links: [["Request a Quote","page-quote"],["Contact A Dealer","page-contact"]] },
      ],
    },
  },
  {
    label: "Company",
    mega: {
      cols: [
        { title: "", links: [["About Us","page-about"],["Contact Us","page-contact"],["Frequently Asked Questions","page-faq"]] },
      ],
    },
  },
];

const PRODUCTS = [
  { title: "Diesel Forklifts 1.5 to 2t, 5 Series", desc: "The 5-Series diesel forklifts provide dependable performance, ease of use, and unbeatable value for money.", img: "https://res.cloudinary.com/doosan-bobcat/image/upload/ar_1.5,c_fill,f_auto,g_auto,q_auto,w_480/v1702831681/bobcat-assets/alao-approved/in/products/material-handling/diesel-forklifts/diesel-forklifts-1-5-to-2t-5-series/20231217-bobcat-alao-in-diesel-forklifts-d18s-5-studio-1" },
  { title: "Diesel Forklifts 2 to 3.5t, 7 Series", desc: "The 7-Series diesel forklifts deliver optimal performance with fuel-efficient, eco-friendly engines, operator comfort, and advanced safety features.", img: "https://res.cloudinary.com/doosan-bobcat/image/upload/ar_1.5,c_fill,f_auto,g_auto,q_auto,w_480/v1702831673/bobcat-assets/alao-approved/in/products/material-handling/diesel-forklifts/diesel-forklifts-2-to-3-5t-7-series/20231217-bobcat-alao-in-diesel-forklifts-d25s-7-studio-1" },
  { title: "Diesel Forklifts 2 to 3.5t, NX Series", desc: "Experience exceptional capability, resiliency, and strength with the NX Series diesel forklifts.", img: "https://res.cloudinary.com/doosan-bobcat/image/upload/ar_1.5,c_fill,f_auto,g_auto,q_auto,w_480/v1702831663/bobcat-assets/alao-approved/in/products/material-handling/diesel-forklifts/diesel-forklifts-2-to-3-5t-nx-series/20231217-bobcat-alao-in-diesel-forklifts-d30nxp-studio-1" },
  { title: "Diesel Forklifts 3.5 to 5.5t, 5 Series", desc: "Our easy-to-use 5-Series 3.5–5.5t diesel forklifts provide dependable performance and reliability with excellent value.", img: "https://res.cloudinary.com/doosan-bobcat/image/upload/ar_1.5,c_fill,f_auto,g_auto,q_auto,w_480/v1702831690/bobcat-assets/alao-approved/in/products/material-handling/diesel-forklifts/diesel-forklifts-3-5-to-5-5t-5-series/20231217-bobcat-alao-in-diesel-forklifts-d50c-5-studio-1" },
  { title: "Diesel Forklifts 4 to 5.5t, 9 Series", desc: "Unleash the power and value of the 9 Series forklifts designed for productivity and user safety. These forklifts exceed expectations.", img: "https://res.cloudinary.com/doosan-bobcat/image/upload/ar_1.5,c_fill,f_auto,g_auto,q_auto,w_480/v1703943164/bobcat-assets/alao-approved/in/products/material-handling/diesel-forklifts/diesel-forklifts-4-to-5-5t-9-series/20231228-bobcat-alao-in-diesel-forklifts-d50sc-9-studio-1" },
  { title: "Diesel Forklifts 6 to 9t, 5 Series", desc: "The 5-Series 6–9t diesel forklifts are built for reliability and durability in demanding industrial environments.", img: "https://res.cloudinary.com/doosan-bobcat/image/upload/ar_1.5,c_fill,f_auto,g_auto,q_auto,w_480/v1702831684/bobcat-assets/alao-approved/in/products/material-handling/diesel-forklifts/diesel-forklifts-6-to-9t-5-series/20231217-bobcat-alao-in-diesel-forklifts-d70s-5-studio-1" },
  { title: "Diesel Forklifts 6 to 9t, 9 Series", desc: "Enhance work efficiency with our 9-Series diesel forklifts that boast improved productivity and fuel economy.", img: "https://res.cloudinary.com/doosan-bobcat/image/upload/ar_1.5,c_fill,f_auto,g_auto,q_auto,w_480/v1702831683/bobcat-assets/alao-approved/in/products/material-handling/diesel-forklifts/diesel-forklifts-6-to-9t-9-series/20231217-bobcat-alao-in-diesel-forklifts-d90s-9-studio-1" },
  { title: "Diesel Forklifts 10 to 16t, 7 Series", desc: "The 10–16t 7-Series diesel forklifts deliver efficient, high-torque engines and a robust chassis for superior reliability.", img: "https://res.cloudinary.com/doosan-bobcat/image/upload/ar_1.5,c_fill,f_auto,g_auto,q_auto,w_480/v1702831670/bobcat-assets/alao-approved/in/products/material-handling/diesel-forklifts/diesel-forklifts-10-to-16t-7-series/20231217-bobcat-alao-in-diesel-forklifts-d160s-7-studio-1" },
  { title: "Diesel Forklifts 18 to 25t, 7 Series", desc: "Our powerful 7-Series 18–25t diesel forklifts excel in the most demanding applications and industries.", img: "https://res.cloudinary.com/doosan-bobcat/image/upload/ar_1.5,c_fill,f_auto,g_auto,q_auto,w_480/v1703942818/bobcat-assets/alao-approved/in/products/material-handling/diesel-forklifts/diesel-forklifts-18-to-25t-7-series/20231228-bobcat-alao-in-diesel-forklifts-dv250s-7-studio-1" },
];

const FOOTER_EQUIPMENT = ["Skid-Steer Loaders","Compact Track Loaders","Backhoe Loaders","Mini Excavators","Attachments"];
const FOOTER_HELP = ["Frequently Asked Questions (FAQs)","Contact Us","Find a Dealer"];

const SOCIAL = [
  { name:"Facebook", icon:"M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" },
  { name:"YouTube", icon:"M22.54 6.42a2.78 2.78 0 00-1.95-1.97C18.88 4 12 4 12 4s-6.88 0-8.59.45A2.78 2.78 0 001.46 6.42 29 29 0 001 12a29 29 0 00.46 5.58 2.78 2.78 0 001.95 1.97C5.12 20 12 20 12 20s6.88 0 8.59-.45a2.78 2.78 0 001.95-1.97A29 29 0 0023 12a29 29 0 00-.46-5.58zM9.75 15.02V8.98L15.5 12l-5.75 3.02z" },
  { name:"Twitter", icon:"M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" },
  { name:"Instagram", icon:"M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01M6.5 3h11A3.5 3.5 0 0121 6.5v11a3.5 3.5 0 01-3.5 3.5h-11A3.5 3.5 0 013 17.5v-11A3.5 3.5 0 016.5 3z" },
  { name:"LinkedIn", icon:"M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z M4 6a2 2 0 100-4 2 2 0 000 4z" },
];

const DEALERS = [
  { name:"KIM AMIR — Dubai Main Office", address:"Building 307, 1st Floor, Office No. C21,Hor Al Anz, Dubai, UAE", phone:"+971556268499", email:"amir@kimheavyequipment.com", hours:"Mon–Sat: 8:00 AM – 6:00 PM" },
  { name:"Muhammad Kashif — Dubai Main Office", address:"Building 307, 1st Floor, Office No. C21, Dubai,Hor Al Anz, UAE", phone:"+971585759923", email:"kasif@kimheavyequipment.com", hours:"Mon–Sat: 8:00 AM – 6:00 PM" },
 ];

const FAQS = [
  { q:"What types of heavy equipment does JINMAN KIM trade in?", a:"JINMAN KIM USED HEAVY EQUIPMENT AND MACHINERY TRADING L.L.C offers a wide range of used heavy equipment including diesel forklifts (1.5t–25t), skid-steer loaders, compact track loaders, mini excavators, backhoe loaders, and other industrial machinery sourced from reputable manufacturers worldwide." },
  { q:"Where is JINMAN KIM located?", a:"Our main operations are based in Dubai, UAE. We operate from Al Quoz Industrial Area with additional offices in Jebel Ali Free Zone (JAFZA), Sharjah, Abu Dhabi, and other Emirates. You can visit us or contact us at admin@kimheavyequipment.com or through our website kimheavyequipment.com." },
  { q:"How do I request a quote for equipment?", a:"You can request a quote by filling out the Request a Quote form on our website with your equipment requirements and contact details. A Kim Heavy Equipment specialist will get in touch within 1–2 business days." },
  { q:"Do you export equipment internationally?", a:"Yes. JINMAN KIM has extensive experience in exporting used heavy equipment from Dubai to markets across the Middle East, Africa, Asia, and beyond. Our team can assist with documentation, logistics, and shipping arrangements." },
  { q:"What is the condition of the used equipment you sell?", a:"All our used equipment undergoes thorough inspection before listing. We provide detailed condition reports, operating hours, and service history where available. Our team ensures transparency so you know exactly what you are purchasing." },
  { q:"Do you offer parts and service support in Dubai?", a:"Yes. We stock a range of spare parts and consumables for the equipment we sell. Our service team in Dubai can assist with maintenance, repairs, and sourcing of parts. Contact your nearest office for support." },
  { q:"Does Kim Heavy Equipment offer operator training?", a:"Yes. We can arrange operator training and safety induction programs for equipment purchased through us. Contact our Dubai office to enquire about available training and scheduling." },
  { q:"What financing options are available?", a:"We work with select financial institutions in the UAE to facilitate equipment financing. Please speak with our sales team in Dubai to discuss current financing options, payment plans, and eligibility criteria." },
];

const PARTS_CATEGORIES = [
  { title:"Tires & Tracks", icon:"🔧", desc:"OEM-spec tires and rubber tracks engineered for maximum traction and durability across all Kim Heavy Equipment machines.", items:["Solid Pneumatic Tires","Air-Filled Pneumatic Tires","Rubber Tracks","Steel Tracks","Wheel Rims & Hardware"] },
  { title:"Batteries", icon:"⚡", desc:"High-performance batteries designed to withstand demanding cycles and Dubai's harsh desert climate conditions.", items:["Lead-Acid Batteries","Lithium-Ion Batteries","Battery Chargers","Battery Cables","Jump-Start Kits"] },
  { title:"Filters", icon:"🔩", desc:"Genuine Kim Heavy Equipment filters that protect your engine and hydraulic systems from contaminants.", items:["Engine Oil Filters","Hydraulic Filters","Air Filters","Fuel Filters","Cabin Air Filters"] },
  { title:"Fluids & Lubricants", icon:"💧", desc:"Kim Heavy Equipment-approved fluids formulated for optimal performance and long component life.", items:["Engine Oil","Hydraulic Fluid","Transmission Fluid","Coolant","Grease & Lubricants"] },
];

// ─── SHARED COMPONENTS ────────────────────────────────────────────────────────

function PageHero({ title, subtitle, img, breadcrumbs, navigate }) {
  return (
    <>
      <div className="hero">
        {img && <img src={img} alt={title} />}
        <div className="hero-overlay">
          <div className="hero-tagline">JINMAN KIM USED HEAVY EQUIPMENT AND MACHINERY TRADING L.L.C</div>
          <div className="hero-title">{title}</div>
        </div>
      </div>
      <div className="breadcrumb">
        <div className="breadcrumb-inner">
          <a href="#" onClick={e=>{e.preventDefault();navigate("page-diesel")}}>Home</a>
          {breadcrumbs.map((b,i)=>(
            <span key={i} style={{display:"flex",alignItems:"center",gap:8}}>
              <span className="breadcrumb-sep">›</span>
              {b.page ? <a href="#" onClick={e=>{e.preventDefault();navigate(b.page)}}>{b.label}</a> : <span>{b.label}</span>}
            </span>
          ))}
        </div>
      </div>
    </>
  );
}

function InnerPageShell({ title, subtitle, img, breadcrumbs, navigate, children }) {
  return (
    <>
      <PageHero title={title} subtitle={subtitle} img={img} breadcrumbs={breadcrumbs} navigate={navigate} />
      <div className="page-content" style={{paddingBottom:60}}>
        <div className="section-title">JINMAN KIM USED HEAVY EQUIPMENT AND MACHINERY TRADING L.L.C</div>
        <h1 className="page-heading">{title}</h1>
        {subtitle && <p className="page-desc">{subtitle}</p>}
        {children}
      </div>
    </>
  );
}

// ─── PAGE: REQUEST A QUOTE ────────────────────────────────────────────────────
function PageQuote({ navigate }) {
  const [form, setForm] = useState({ firstName:"", lastName:"", email:"", phone:"", company:"", city:"", product:"", capacity:"", message:"", consent:false });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [sendError, setSendError] = useState("");
  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  const handleQuoteSubmit = async () => {
    if (!form.firstName || !form.email || !form.phone || !form.city || !form.product || !form.consent) return;
    setSending(true);
    setSendError("");
    try {
      await emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_QUOTE_TEMPLATE, {
        first_name:  form.firstName,
        last_name:   form.lastName,
        email:       form.email,
        phone:       form.phone,
        company:     form.company || "N/A",
        city:        form.city,
        product:     form.product,
        capacity:    form.capacity || "Not specified",
        message:     form.message || "No additional requirements.",
      });
      setSubmitted(true);
    } catch (err) {
      setSendError("Failed to send. Please try again or email us directly.");
    } finally {
      setSending(false);
    }
  };

  if (submitted) return (
    <InnerPageShell title="Request a Quote" breadcrumbs={[{label:"Buying Tools"},{label:"Request a Quote"}]} navigate={navigate}>
      <div style={{textAlign:"center",padding:"60px 0"}}>
        <div style={{fontSize:64,marginBottom:16}}>✅</div>
        <h2 style={{fontSize:28,fontWeight:900,color:"#1a1a1a",marginBottom:12}}>Thank You!</h2>
        <p style={{color:"#555",fontSize:15,marginBottom:32,maxWidth:480,margin:"0 auto 32px"}}>Your quote request has been submitted. A JINMAN KIM representative will contact you within 1–2 business days.</p>
        <button className="cta-btn cta-btn-primary" style={{cursor:"pointer"}} onClick={()=>navigate("page-diesel")}>Back to Diesel Forklifts</button>
      </div>
    </InnerPageShell>
  );

  return (
    <InnerPageShell
      title="Request a Quote"
      subtitle="Tell us about your requirements and a JINMAN KIM specialist will get back to you with a personalised quote."
      img="./bg.png"
      breadcrumbs={[{label:"Buying Tools"},{label:"Request a Quote"}]}
      navigate={navigate}
    >
      <div className="form-card">
        <div className="form-section-label">Personal Information</div>
        <div className="form-row-2">
          <div className="form-group">
            <label className="form-label">First Name <span className="req">*</span></label>
            <input className="form-input" value={form.firstName} onChange={e=>set("firstName",e.target.value)} placeholder="Enter first name" />
          </div>
          <div className="form-group">
            <label className="form-label">Last Name <span className="req">*</span></label>
            <input className="form-input" value={form.lastName} onChange={e=>set("lastName",e.target.value)} placeholder="Enter last name" />
          </div>
        </div>
        <div className="form-row-2">
          <div className="form-group">
            <label className="form-label">Email Address <span className="req">*</span></label>
            <input className="form-input" type="email" value={form.email} onChange={e=>set("email",e.target.value)} placeholder="you@company.com" />
          </div>
          <div className="form-group">
            <label className="form-label">Phone Number <span className="req">*</span></label>
            <input className="form-input" value={form.phone} onChange={e=>set("phone",e.target.value)} placeholder="+971 XX XXX XXXX" />
          </div>
        </div>
        <div className="form-row-2">
          <div className="form-group">
            <label className="form-label">Company Name</label>
            <input className="form-input" value={form.company} onChange={e=>set("company",e.target.value)} placeholder="Your company" />
          </div>
          <div className="form-group">
            <label className="form-label">City / Location <span className="req">*</span></label>
            <input className="form-input" value={form.city} onChange={e=>set("city",e.target.value)} placeholder="e.g. Dubai" />
          </div>
        </div>

        <div className="form-divider" />
        <div className="form-section-label">Equipment Requirements</div>

        <div className="form-row-2">
          <div className="form-group">
            <label className="form-label">Product of Interest <span className="req">*</span></label>
            <select className="form-input" value={form.product} onChange={e=>set("product",e.target.value)}>
              <option value="">Select product</option>
              <option>Diesel Forklifts – 5 Series (1.5–2t)</option>
              <option>Diesel Forklifts – 7 Series (2–3.5t)</option>
              <option>Diesel Forklifts – NX Series (2–3.5t)</option>
              <option>Diesel Forklifts – 5 Series (3.5–5.5t)</option>
              <option>Diesel Forklifts – 9 Series (4–5.5t)</option>
              <option>Diesel Forklifts – 5 Series (6–9t)</option>
              <option>Diesel Forklifts – 9 Series (6–9t)</option>
              <option>Diesel Forklifts – 7 Series (10–16t)</option>
              <option>Diesel Forklifts – 7 Series (18–25t)</option>
              <option>Electric Forklifts</option>
              <option>Skid-Steer Loaders</option>
              <option>Compact Track Loaders</option>
              <option>Mini Excavators</option>
              <option>Other</option>
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Required Capacity</label>
            <select className="form-input" value={form.capacity} onChange={e=>set("capacity",e.target.value)}>
              <option value="">Select capacity</option>
              <option>1.5 – 2 tonnes</option>
              <option>2 – 3.5 tonnes</option>
              <option>3.5 – 5.5 tonnes</option>
              <option>4 – 5.5 tonnes</option>
              <option>6 – 9 tonnes</option>
              <option>10 – 16 tonnes</option>
              <option>18 – 25 tonnes</option>
              <option>Not sure</option>
            </select>
          </div>
        </div>
        <div className="form-group">
          <label className="form-label">Additional Requirements / Message</label>
          <textarea className="form-input form-textarea" value={form.message} onChange={e=>set("message",e.target.value)} placeholder="Describe your application, site conditions, or any specific requirements..." />
        </div>

        <div className="form-group" style={{flexDirection:"row",alignItems:"flex-start",gap:12,marginTop:8}}>
          <input type="checkbox" id="consent" checked={form.consent} onChange={e=>set("consent",e.target.checked)} style={{marginTop:3,accentColor:"#e8a000",width:16,height:16,cursor:"pointer"}} />
          <label htmlFor="consent" style={{fontSize:13,color:"#555",lineHeight:1.6,cursor:"pointer"}}>
            I consent to Kim Heavy Equipment Dubai processing my personal data to respond to this enquiry and send relevant product information. I can withdraw consent at any time.
          </label>
        </div>

        <div style={{marginTop:28}}>
          <button
            className="cta-btn cta-btn-primary"
            style={{fontSize:14,padding:"14px 40px",cursor:sending?"not-allowed":"pointer",opacity:sending?0.7:1}}
            onClick={handleQuoteSubmit}
            disabled={sending}
          >
            {sending ? "Sending…" : "Submit Request →"}
          </button>
          {sendError && <p style={{fontSize:13,color:"#c0392b",marginTop:10}}>{sendError}</p>}
          <p style={{fontSize:12,color:"#aaa",marginTop:12}}>* Required fields. We typically respond within 1–2 business days.</p>
        </div>
      </div>

      {/* Why Kim Heavy Equipment aside */}
      <div className="quote-aside">
        <div className="aside-card">
          <div className="aside-icon">🏆</div>
          <div className="aside-title">Industry Leader</div>
          <div className="aside-text">Over 60 years of innovation in compact equipment with a proven track record worldwide.</div>
        </div>
        <div className="aside-card">
          <div className="aside-icon">🔧</div>
          <div className="aside-title">Nationwide Service</div>
          <div className="aside-text">Authorised dealer network across the UAE providing expert service, parts, and support.</div>
        </div>
        <div className="aside-card">
          <div className="aside-icon">💰</div>
          <div className="aside-title">Low Total Cost</div>
          <div className="aside-text">Designed for fuel efficiency and long service intervals to minimise your operating costs.</div>
        </div>
      </div>
    </InnerPageShell>
  );
}

// ─── PAGE: CONTACT A DEALER ───────────────────────────────────────────────────
function PageContact({ navigate }) {
  const [form, setForm] = useState({ name:"", email:"", phone:"", subject:"General Enquiry", message:"", dealer:"" });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [sendError, setSendError] = useState("");
  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  const handleContactSubmit = async () => {
    if (!form.name || !form.email || !form.message) return;
    setSending(true);
    setSendError("");
    try {
      await emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_CONTACT_TEMPLATE, {
        name:    form.name,
        email:   form.email,
        phone:   form.phone || "Not provided",
        dealer:  form.dealer || "No preference",
        subject: form.subject,
        message: form.message,
      });
      setSubmitted(true);
    } catch (err) {
      setSendError("Failed to send. Please try again or email us directly.");
    } finally {
      setSending(false);
    }
  };

  if (submitted) return (
    <InnerPageShell title="Contact A Dealer" breadcrumbs={[{label:"Buying Tools"},{label:"Contact A Dealer"}]} navigate={navigate}>
      <div style={{textAlign:"center",padding:"60px 0"}}>
        <div style={{fontSize:64,marginBottom:16}}>✅</div>
        <h2 style={{fontSize:28,fontWeight:900,color:"#1a1a1a",marginBottom:12}}>Message Sent!</h2>
        <p style={{color:"#555",fontSize:15,marginBottom:32,maxWidth:480,margin:"0 auto 32px"}}>Your message has been forwarded to the dealer. Expect a response within 24 hours on business days.</p>
        <button className="cta-btn cta-btn-primary" style={{cursor:"pointer"}} onClick={()=>navigate("page-diesel")}>Back to Diesel Forklifts</button>
      </div>
    </InnerPageShell>
  );

  return (
    <InnerPageShell
      title="Contact A Dealer"
      subtitle="Reach out to our Dubai office for equipment inquiries, service bookings, product demos, or any other assistance."
      img="./bg.png" 
      breadcrumbs={[{label:"Buying Tools"},{label:"Contact A Dealer"}]}
      navigate={navigate} 
    >
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))",gap:40,marginTop:8}}>
        <div className="form-card" style={{margin:0}}>
          <div className="form-section-label">Send a Message</div>
          <div className="form-group">
            <label className="form-label">Full Name <span className="req">*</span></label>
            <input className="form-input" value={form.name} onChange={e=>set("name",e.target.value)} placeholder="Your full name" />
          </div>
          <div className="form-row-2">
            <div className="form-group">
              <label className="form-label">Email <span className="req">*</span></label>
              <input className="form-input" type="email" value={form.email} onChange={e=>set("email",e.target.value)} placeholder="you@email.com" />
            </div>
            <div className="form-group">
              <label className="form-label">Phone</label>
              <input className="form-input" value={form.phone} onChange={e=>set("phone",e.target.value)} placeholder="+971 XX XXX XXXX" />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Preferred Dealer</label>
            <select className="form-input" value={form.dealer} onChange={e=>set("dealer",e.target.value)}>
              <option value="">Select nearest dealer</option>
              {DEALERS.map(d=><option key={d.name}>{d.name}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Subject</label>
            <select className="form-input" value={form.subject} onChange={e=>set("subject",e.target.value)}>
              <option>General Enquiry</option>
              <option>Product Demo Request</option>
              <option>Service Booking</option>
              <option>Parts Enquiry</option>
              <option>Financing Enquiry</option>
              <option>Warranty Claim</option>
              <option>Other</option>
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Message <span className="req">*</span></label>
            <textarea className="form-input form-textarea" value={form.message} onChange={e=>set("message",e.target.value)} placeholder="How can we help you?" />
          </div>
          <button
            className="cta-btn cta-btn-primary"
            style={{fontSize:14,padding:"14px 40px",cursor:sending?"not-allowed":"pointer",opacity:sending?0.7:1,marginTop:8}}
            onClick={handleContactSubmit}
            disabled={sending}
          >
            {sending ? "Sending…" : "Send Message →"}
          </button>
          {sendError && <p style={{fontSize:13,color:"#c0392b",marginTop:10}}>{sendError}</p>}
        </div>

      
      </div>
    </InnerPageShell>
  );
}

// ─── PAGE: FIND A DEALER ──────────────────────────────────────────────────────


// ─── PAGE: PARTS & SERVICE ────────────────────────────────────────────────────
function PageParts({ navigate }) {
  const [activeTab, setActiveTab] = useState("parts");
  return (
    <InnerPageShell
      title="Parts & Service"
      subtitle="Genuine parts and expert service to keep your equipment running at peak performance."
     img="./bg.png" 
       breadcrumbs={[{label:"Parts & Service"}]}
      navigate={navigate}
    >
      <div className="tab-bar">
        <button className={`tab-btn${activeTab==="parts"?" tab-active":""}`} onClick={()=>setActiveTab("parts")}>Parts</button>
        <button className={`tab-btn${activeTab==="service"?" tab-active":""}`} onClick={()=>setActiveTab("service")}>Service</button>
        <button className={`tab-btn${activeTab==="warranty"?" tab-active":""}`} onClick={()=>setActiveTab("warranty")}>Warranty</button>
      </div>

      {activeTab==="parts" && (
        <div>
          <p className="page-desc" style={{marginBottom:32}}>Use genuine Kim Heavy Equipment parts to protect your investment, maintain peak performance, and preserve your warranty coverage.</p>
          <div className="parts-grid">
            {PARTS_CATEGORIES.map(p=>(
              <div key={p.title} className="parts-card">
                <div className="parts-icon">{p.icon}</div>
                <div className="parts-title">{p.title}</div>
                <div className="parts-desc">{p.desc}</div>
                <ul className="parts-list">
                  {p.items.map(i=><li key={i}>{i}</li>)}
                </ul>
                <button className="cta-btn cta-btn-primary" style={{fontSize:12,padding:"10px 20px",marginTop:16,cursor:"pointer"}} onClick={()=>navigate("page-contact")}>Enquire Now</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {activeTab==="service" && (
        <div>
          <p className="page-desc" style={{marginBottom:32}}>Our UAE-wide service network ensures minimal downtime and maximum productivity for your equipment fleet.</p>
          <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:24}}>
            {[
              {icon:"📅",title:"Service Schedules",desc:"Follow manufacturer-recommended service intervals to extend machine life and prevent costly breakdowns. Schedules vary by model and operating hours."},
              {icon:"🎬",title:"Maintenance Videos",desc:"Access step-by-step instructional videos for common maintenance tasks. Available for all Kim Heavy Equipment equipment models sold in Dubai."},
              {icon:"🔧",title:"Field Service",desc:"Kim Heavy Equipment technicians are available for on-site diagnostics and repairs. Contact your nearest dealer to schedule a field service visit."},
              {icon:"📊",title:"Telematics & Diagnostics",desc:"Advanced onboard diagnostics help technicians identify issues quickly. Some models support remote diagnostics for proactive maintenance."},
            ].map(s=>(
              <div key={s.title} className="service-card">
                <div style={{fontSize:32,marginBottom:12}}>{s.icon}</div>
                <div style={{fontWeight:700,fontSize:16,marginBottom:8,textTransform:"uppercase",letterSpacing:"0.04em"}}>{s.title}</div>
                <div style={{fontSize:13,color:"#555",lineHeight:1.7}}>{s.desc}</div>
              </div>
            ))}
          </div>
          <div style={{marginTop:32}}>
            <button className="cta-btn cta-btn-primary" style={{cursor:"pointer"}} onClick={()=>navigate("page-contact")}>Book a Service →</button>
          </div>
        </div>
      )}

      {activeTab==="warranty" && (
        <div>
          <p className="page-desc" style={{marginBottom:32}}>Our warranty plans are designed to give you peace of mind and protect your investment.</p>
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:24}}>
            {[
              {title:"Standard Warranty",duration:"12 Months",features:["Covers manufacturing defects","Engine & drivetrain","Hydraulic system","Electrical components","Nationwide dealer support"]},
              {title:"Extended Warranty",duration:"Up to 36 Months",features:["All Standard Warranty coverage","Additional 12 or 24 months","Priority service scheduling","Roadside assistance","Transferable to new owner"]},
              {title:"PowerTrain Plus",duration:"Up to 60 Months",features:["Engine protection","Transmission coverage","Axle & differential","Hydraulic pumps & motors","Comprehensive peace of mind"]},
            ].map(w=>(
              <div key={w.title} className="warranty-card">
                <div className="warranty-badge">{w.duration}</div>
                <div style={{fontWeight:800,fontSize:17,marginBottom:16,textTransform:"uppercase",letterSpacing:"0.04em"}}>{w.title}</div>
                <ul style={{listStyle:"none",display:"flex",flexDirection:"column",gap:8}}>
                  {w.features.map(f=>(
                    <li key={f} style={{fontSize:13,color:"#444",display:"flex",gap:8,alignItems:"flex-start"}}>
                      <span style={{color:"#e8a000",fontWeight:700,marginTop:1}}>✓</span>{f}
                    </li>
                  ))}
                </ul>
                <button className="cta-btn cta-btn-primary" style={{fontSize:12,padding:"10px 20px",marginTop:20,cursor:"pointer",width:"100%"}} onClick={()=>navigate("page-contact")}>Learn More</button>
              </div>
            ))}
          </div>
        </div>
      )}
    </InnerPageShell>
  );
}

// ─── PAGE: ABOUT KIM HEAVY EQUIPMENT ───────────────────────────────────────────────────────
function PageAbout({ navigate }) {
  return (
    <InnerPageShell
      title="About Us"
      subtitle="Your trusted partner for used heavy equipment and machinery trading in Dubai, UAE."
     img="./bg.png" 
       breadcrumbs={[{label:"Company"},{label:"About Us"}]}
      navigate={navigate}
    >
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:48,marginBottom:48}}>
        <div>
          <h2 style={{fontSize:22,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.04em",marginBottom:16,color:"#1a1a1a"}}>Our Story</h2>
          <p style={{fontSize:14,lineHeight:1.8,color:"#444",marginBottom:16}}>JINMAN KIM USED HEAVY EQUIPMENT AND MACHINERY TRADING L.L.C was founded in the Republic of Korea before establishing its operations in Dubai, UAE. What began as a specialized trading operation in Asia has grown into a trusted name in the heavy equipment industry across the Middle East.</p>
          <p style={{fontSize:14,lineHeight:1.8,color:"#444",marginBottom:16}}>Today, Kim Heavy Equipment is a leading supplier of used heavy machinery and equipment in Dubai, UAE, offering a comprehensive lineup that includes forklifts, loaders, excavators, and industrial machinery — all sourced and inspected to deliver maximum value and reliability.</p>
          <p style={{fontSize:14,lineHeight:1.8,color:"#444"}}>Operating from Dubai, Kim Heavy Equipment serves customers across the UAE and the wider Middle East region, providing world-class used equipment, genuine parts, and expert service to clients in construction, logistics, oil & gas, and industrial sectors.</p>
        </div>
        <div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
            {[
              {stat:"20+",label:"Years of Experience"},
              {stat:"500+",label:"Equipment Units Traded"},
              {stat:"30+",label:"Countries Served"},
              {stat:"1,000+",label:"Satisfied Clients"},
            ].map(s=>(
              <div key={s.stat} style={{background:"#1a1a1a",color:"#fff",padding:"28px 20px",textAlign:"center"}}>
                <div style={{fontSize:36,fontWeight:900,color:"#e8a000",lineHeight:1}}>{s.stat}</div>
                <div style={{fontSize:12,letterSpacing:"0.08em",textTransform:"uppercase",color:"#aaa",marginTop:8}}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={{background:"#f5f5f5",padding:"40px 36px",marginBottom:48}}>
        <h2 style={{fontSize:20,fontWeight:800,textTransform:"uppercase",letterSpacing:"0.04em",marginBottom:24,color:"#1a1a1a"}}>Innovation at Our Core</h2>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:24}}>
          {[
            {icon:"⚙️",title:"Engineering Excellence",desc:"Our team leverages deep industry knowledge to source, inspect, and deliver high-quality used equipment that meets international standards."},
            {icon:"🌱",title:"Sustainability",desc:"We prioritize responsible trading practices, offering equipment that meets UAE environmental and safety regulations."},
            {icon:"🛡️",title:"Safety First",desc:"Every unit we trade undergoes rigorous inspection to ensure safe operation and compliance with local regulations in Dubai and the UAE."},
          ].map(i=>(
            <div key={i.title} style={{textAlign:"center",padding:"0 12px"}}>
              <div style={{fontSize:40,marginBottom:12}}>{i.icon}</div>
              <div style={{fontWeight:700,fontSize:14,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:8}}>{i.title}</div>
              <div style={{fontSize:13,color:"#555",lineHeight:1.7}}>{i.desc}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{display:"flex",gap:16,flexWrap:"wrap"}}>
        <button className="cta-btn cta-btn-primary" style={{cursor:"pointer"}} onClick={()=>navigate("page-quote")}>Request a Quote →</button>
        <button className="cta-btn cta-btn-secondary" style={{cursor:"pointer",borderColor:"#1a1a1a",color:"#1a1a1a"}} onClick={()=>navigate("page-dealer")}>Find a Dealer →</button>
      </div>
    </InnerPageShell>
  );
}

// ─── PAGE: FAQ ────────────────────────────────────────────────────────────────
function PageFAQ({ navigate }) {
  const [open, setOpen] = useState(null);
  return (
    <InnerPageShell
      title="Frequently Asked Questions"
      subtitle="Find answers to the most common questions about Kim Heavy Equipment equipment, service, and purchasing."
  img="./bg.png" 
      breadcrumbs={[{label:"Company"},{label:"Frequently Asked Questions"}]}
      navigate={navigate}
    >
      <div style={{maxWidth:780}}>
        {FAQS.map((f,i)=>(
          <div key={i} className="faq-item">
            <button className="faq-q" onClick={()=>setOpen(open===i?null:i)}>
              <span>{f.q}</span>
              <span className={`faq-arrow${open===i?" faq-arrow-open":""}`}>›</span>
            </button>
            {open===i && <div className="faq-a">{f.a}</div>}
          </div>
        ))}
      </div>

      <div className="info-banner" style={{marginTop:40,maxWidth:780}}>
        <div className="info-banner-icon">💬</div>
        <div>
          <strong>Didn't find your answer?</strong> Our team is happy to help.{" "}
          <a href="#" onClick={e=>{e.preventDefault();navigate("page-contact")}} style={{color:"#e8a000"}}>Contact a dealer</a> or{" "}
          <a href="#" onClick={e=>{e.preventDefault();navigate("page-quote")}} style={{color:"#e8a000"}}>request a quote</a> and we'll get back to you promptly.
        </div>
      </div>
    </InnerPageShell>
  );
}

// ─── PAGE: DIESEL FORKLIFTS (MAIN) ───────────────────────────────────────────
function PageDiesel({ navigate }) {
  return (
    <>
      <div className="hero">
        <img src="./bg.png" />
        <div className="hero-overlay">
          <div className="hero-tagline">JINMAN KIM USED HEAVY EQUIPMENT AND MACHINERY TRADING L.L.C</div>
          <div className="hero-title">Where Power Meets Reliability</div>
        </div>
      </div>
      <div className="breadcrumb">
        <div className="breadcrumb-inner">
          <a href="#" onClick={e=>e.preventDefault()}>Home</a>
          <span className="breadcrumb-sep">›</span>
          <a href="#" onClick={e=>e.preventDefault()}>Equipment</a>
          <span className="breadcrumb-sep">›</span>
          <span>Diesel Forklifts</span>
        </div>
      </div>
      <div className="page-content">
        <div className="section-title">Equipment</div>
        <h1 className="page-heading">Diesel Forklifts</h1>
        <p className="page-desc">Experience the power and precision of Kim Heavy Equipment diesel forklifts. Designed for high-performance capabilities, they effortlessly handle tough tasks. With powerful engines and smooth controls, these forklifts ensure seamless operation. Enjoy low total cost of ownership for maximum productivity and profitability.</p>
        <div className="product-grid">
          {PRODUCTS.map(p=>(
            <div key={p.title} className="product-card">
              <a href="#" onClick={e=>e.preventDefault()}>
                <img className="product-img" src={p.img} alt={p.title} loading="lazy" />
                <div className="product-body">
                  <div className="product-title">{p.title}</div>
                  <div className="product-desc">{p.desc}</div>
                  <span className="learn-more">Learn More <span className="learn-more-arrow"/></span>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
      <div className="cta-strip">
        <div className="cta-inner">
          <button className="cta-btn cta-btn-primary" style={{cursor:"pointer"}} onClick={()=>navigate("page-quote")}>Request a Quote</button>
          <button className="cta-btn cta-btn-secondary" style={{cursor:"pointer"}} onClick={()=>navigate("page-dealer")}>Find a Dealer</button>
          <button className="cta-btn cta-btn-secondary" style={{cursor:"pointer"}} onClick={()=>navigate("page-equipment")}>All Equipment</button>
          <button className="cta-btn cta-btn-secondary" style={{cursor:"pointer"}} onClick={()=>navigate("page-parts")}>Parts & Service</button>
        </div>
      </div>
      <div className="related-section">
        <div className="related-group">
          <div className="related-group-title">Parts and Service</div>
          {["Parts Overview","Service Overview","Maintenance Videos","Service Schedules","Warranty Plans"].map(l=>(
            <a key={l} href="#" onClick={e=>{e.preventDefault();navigate("page-parts")}}>{l}</a>
          ))}
        </div>
        <div className="related-group">
          <div className="related-group-title">Need Assistance?</div>
          <a href="#" onClick={e=>{e.preventDefault();navigate("page-dealer")}}>Find a Local Dealer</a>
          <a href="#" onClick={e=>{e.preventDefault();navigate("page-faq")}}>Frequently Asked Questions</a>
        </div>
      
      </div>
    </>
  );
}

// ─── PAGE: EQUIPMENT (generic placeholder) ────────────────────────────────────
function PageEquipment({ navigate }) {
  return (
    <InnerPageShell
      title="All Equipment"
      subtitle="Explore the full range of used heavy equipment available at JINMAN KIM — from compact loaders and excavators to forklifts and industrial machinery."
      img="./bg.png"
      breadcrumbs={[{label:"Equipment"}]}
      navigate={navigate}
    >
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:24,marginTop:8}}>
        {[
          {name:"Diesel Forklifts",page:"page-diesel",img:PRODUCTS[0].img,desc:"High-performance diesel forklifts from 1.5t to 25t capacity."},
          {name:"Skid-Steer Loaders",page:"page-equipment",img:"https://res.cloudinary.com/doosan-bobcat/image/upload/ar_1.5,c_fill,f_auto,g_auto,q_auto,w_480/v1702831681/bobcat-assets/alao-approved/in/products/material-handling/diesel-forklifts/diesel-forklifts-1-5-to-2t-5-series/20231217-bobcat-alao-in-diesel-forklifts-d18s-5-studio-1",desc:"Versatile and manoeuvrable loaders for tight spaces."},
          {name:"Compact Track Loaders",page:"page-equipment",img:PRODUCTS[2].img,desc:"Maximum traction on soft and uneven terrain."},
          {name:"Mini Excavators",page:"page-equipment",img:PRODUCTS[3].img,desc:"Precision digging in confined areas."},
          {name:"Electric Forklifts",page:"page-equipment",img:PRODUCTS[4].img,desc:"Zero-emission performance for indoor operations."},
          {name:"Backhoe Loaders",page:"page-equipment",img:PRODUCTS[5].img,desc:"Combined digging and loading capability."},
        ].map(e=>(
          <div key={e.name} className="product-card">
            <a href="#" onClick={ev=>{ev.preventDefault();navigate(e.page)}}>
              <img className="product-img" src={e.img} alt={e.name} />
              <div className="product-body">
                <div className="product-title">{e.name}</div>
                <div className="product-desc">{e.desc}</div>
                <span className="learn-more">Learn More <span className="learn-more-arrow"/></span>
              </div>
            </a>
          </div>
        ))}
      </div>
    </InnerPageShell>
  );
}

// ─── SHARED LAYOUT: NAV + FOOTER ─────────────────────────────────────────────
function Layout({ children, navigate, currentPage }) {
  const [activeNav, setActiveNav] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileExpanded, setMobileExpanded] = useState(null);

  const go = (page) => { navigate(page); setMobileOpen(false); setActiveNav(null); };

  return (
    <div style={{fontFamily:"'Helvetica Neue', Helvetica, Arial, sans-serif",margin:0,padding:0,color:"#1a1a1a",background:"#fff"}}>
      <style>{`
        *{box-sizing:border-box;margin:0;padding:0;}
        a{text-decoration:none;color:inherit;}
        button{cursor:pointer;border:none;background:none;}
        input,select,textarea{font-family:inherit;}

        .utility-bar{background:#1a1a1a;color:#fff;display:flex;justify-content:flex-end;align-items:center;padding:0 24px;height:45px;}
        .utility-bar a{color:#fff;padding:0 14px;height:36px;display:flex;align-items:center;border-left:1px solid #444;font-size:12px;letter-spacing:.02em;transition:background .15s;cursor:pointer;}
        .utility-bar a:first-child{border-left:none;}
        .utility-bar a:hover{background:#333;}

        .main-nav{background:#fff;border-bottom:1px solid #e0e0e0;position:sticky;top:0;z-index:1000;box-shadow:0 2px 8px rgba(0,0,0,.07);height:100px;}
        .nav-inner{max-width:1280px;margin:0 auto;display:flex;align-items:stretch;padding:0 24px;height:100px;}
        .nav-logo{display:flex;align-items:center;margin-right:32px;flex-shrink:0;cursor:pointer;}
        .nav-logo img{height:28px;width:auto;}
        .nav-links{display:flex;align-items:stretch;flex:1;}
        .nav-item{position:relative;display:flex;align-items:center;}
        .nav-item>button{height:60px;padding:0 16px;font-size:13px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;color:#1a1a1a;display:flex;align-items:center;gap:5px;transition:color .15s;border-bottom:3px solid transparent;}
        .nav-item>button:hover,.nav-item.active>button{color:#e8a000;border-bottom-color:#e8a000;}
        .nav-chevron{width:10px;height:10px;border-right:2px solid currentColor;border-bottom:2px solid currentColor;transform:rotate(45deg);margin-top:-3px;transition:transform .2s;}
        .nav-item.active .nav-chevron{transform:rotate(-135deg);margin-top:3px;}

        .mega-menu{position:absolute;top:60px;left:0;min-width:560px;background:#fff;border-top:3px solid #e8a000;box-shadow:0 8px 32px rgba(0,0,0,.13);display:flex;gap:0;padding:24px 28px;z-index:999;animation:fadeDown .18s ease;}
        @keyframes fadeDown{from{opacity:0;transform:translateY(-8px)}to{opacity:1;transform:translateY(0)}}
        .mega-col{min-width:160px;padding-right:32px;}
        .mega-col-title{font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#888;margin-bottom:10px;padding-bottom:6px;border-bottom:1px solid #e8e8e8;}
        .mega-col a{display:block;font-size:13px;color:#1a1a1a;padding:5px 0;transition:color .13s,padding-left .13s;cursor:pointer;}
        .mega-col a:hover{color:#e8a000;padding-left:4px;}

        .hamburger{display:none;flex-direction:column;gap:5px;padding:8px;}
        .hamburger span{display:block;width:24px;height:2px;background:#1a1a1a;}

        .hero{position:relative;width:100%;height:480px;overflow:hidden;background:#111;}
        .hero img{width:100%;height:100%;object-fit:cover;opacity:.75;}
        .hero-overlay{position:absolute;inset:0;background:linear-gradient(to right,rgba(0,0,0,.55) 0%,rgba(0,0,0,.15) 60%,transparent 100%);display:flex;flex-direction:column;justify-content:center;padding:0 80px;}
        .hero-tagline{font-size:13px;font-weight:700;letter-spacing:.18em;text-transform:uppercase;color:#e8a000;margin-bottom:12px;}
        .hero-title{font-size:clamp(28px,4vw,52px);font-weight:900;color:#fff;letter-spacing:-.01em;line-height:1.1;text-transform:uppercase;max-width:520px;}

        .breadcrumb{background:#f5f5f5;border-bottom:1px solid #e0e0e0;}
        .breadcrumb-inner{max-width:1280px;margin:0 auto;padding:10px 32px;display:flex;align-items:center;gap:8px;font-size:12px;color:#666;flex-wrap:wrap;}
        .breadcrumb a{color:#e8a000;cursor:pointer;}
        .breadcrumb a:hover{text-decoration:underline;}
        .breadcrumb-sep{color:#bbb;font-size:11px;}

        .page-content{max-width:1280px;margin:0 auto;padding:40px 32px 0;}
        .section-title{font-size:13px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#e8a000;margin-bottom:6px;}
        .page-heading{font-size:clamp(24px,3vw,40px);font-weight:900;color:#1a1a1a;letter-spacing:-.02em;text-transform:uppercase;margin-bottom:16px;}
        .page-desc{font-size:15px;line-height:1.7;color:#444;max-width:740px;margin-bottom:40px;}

        .product-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:0;border-top:1px solid #e0e0e0;border-left:1px solid #e0e0e0;}
        .product-card{border-right:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0;display:flex;flex-direction:column;background:#fff;transition:box-shadow .2s;overflow:hidden;}
        .product-card:hover{box-shadow:inset 0 0 0 2px #e8a000;z-index:1;}
        .product-card a{display:flex;flex-direction:column;height:100%;}
        .product-img{width:100%;aspect-ratio:3/2;object-fit:cover;display:block;background:#f0f0f0;transition:transform .35s ease;}
        .product-card:hover .product-img{transform:scale(1.03);}
        .product-body{padding:20px 22px 22px;display:flex;flex-direction:column;flex:1;}
        .product-title{font-size:15px;font-weight:700;color:#1a1a1a;margin-bottom:8px;line-height:1.3;text-transform:uppercase;letter-spacing:.01em;}
        .product-desc{font-size:13px;color:#555;line-height:1.6;flex:1;margin-bottom:16px;}
        .learn-more{display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#e8a000;transition:gap .2s;}
        .learn-more:hover{gap:10px;}
        .learn-more-arrow{width:14px;height:14px;border-top:2px solid #e8a000;border-right:2px solid #e8a000;transform:rotate(45deg);flex-shrink:0;}

        .cta-strip{background:#1a1a1a;padding:28px 32px;margin-top:48px;}
        .cta-inner{max-width:1280px;margin:0 auto;display:flex;gap:16px;flex-wrap:wrap;align-items:center;}
        .cta-btn{display:inline-flex;align-items:center;gap:8px;padding:12px 28px;font-size:12px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;transition:all .18s;border:2px solid transparent;}
        .cta-btn-primary{background:#e8a000;color:#fff;}
        .cta-btn-primary:hover{background:#cf8e00;}
        .cta-btn-secondary{background:transparent;color:#fff;border-color:#fff;}
        .cta-btn-secondary:hover{background:#fff;color:#1a1a1a;}

        .related-section{max-width:1280px;margin:0 auto;padding:48px 32px;display:grid;grid-template-columns:repeat(3,1fr);gap:40px;}
        .related-group-title{font-size:13px;font-weight:800;text-transform:uppercase;letter-spacing:.08em;color:#1a1a1a;margin-bottom:14px;padding-bottom:8px;border-bottom:3px solid #e8a000;}
        .related-group a{display:block;font-size:13px;color:#333;padding:6px 0;border-bottom:1px solid #f0f0f0;transition:color .15s,padding-left .15s;cursor:pointer;}
        .related-group a:hover{color:#e8a000;padding-left:6px;}

        /* FORMS */
        .form-card{background:#fff;border:1px solid #e0e0e0;padding:32px;margin-bottom:0;}
        .form-section-label{font-size:11px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:#e8a000;margin-bottom:20px;padding-bottom:8px;border-bottom:2px solid #e8a000;}
        .form-row-2{display:grid;grid-template-columns:1fr 1fr;gap:16px;}
        .form-group{display:flex;flex-direction:column;gap:6px;margin-bottom:16px;}
        .form-label{font-size:12px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:#555;}
        .req{color:#e8a000;}
        .form-input{padding:11px 14px;border:1px solid #ddd;font-size:14px;color:#1a1a1a;outline:none;transition:border-color .15s,box-shadow .15s;background:#fff;width:100%;}
        .form-input:focus{border-color:#e8a000;box-shadow:0 0 0 3px rgba(232,160,0,.12);}
        .form-textarea{min-height:120px;resize:vertical;}
        .form-divider{border:none;border-top:1px solid #e8e8e8;margin:24px 0;}
        select.form-input{appearance:none;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23555' d='M6 8L1 3h10z'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 12px center;padding-right:32px;}

        /* QUOTE ASIDE */
        .quote-aside{display:flex;flex-direction:column;gap:16px;margin-top:32px;}
        .aside-card{border-left:4px solid #e8a000;padding:16px 20px;background:#fafafa;}
        .aside-icon{font-size:24px;margin-bottom:6px;}
        .aside-title{font-weight:700;font-size:14px;text-transform:uppercase;letter-spacing:.06em;margin-bottom:4px;}
        .aside-text{font-size:13px;color:#555;line-height:1.6;}

        /* DEALERS */
        .dealer-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;}
        .dealer-card{border:1px solid #e0e0e0;padding:0;cursor:pointer;transition:all .2s;overflow:hidden;}
        .dealer-card:hover{border-color:#e8a000;}
        .dealer-card-active{border-color:#e8a000;box-shadow:0 4px 20px rgba(232,160,0,.15);}
        .dealer-header{background:#1a1a1a;padding:14px 18px;}
        .dealer-badge{font-size:10px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:#e8a000;margin-bottom:4px;}
        .dealer-name{font-size:15px;font-weight:700;color:#fff;}
        .dealer-body{padding:16px 18px;}
        .dealer-info-row{display:flex;align-items:flex-start;gap:8px;font-size:13px;color:#444;margin-bottom:8px;line-height:1.4;}
        .dealer-icon{flex-shrink:0;margin-top:1px;}
        .dealer-info-row a{color:#e8a000;}
        .dealer-info-row a:hover{text-decoration:underline;}
        .dealer-expanded{padding:0 18px 18px;}
        .dealer-mini-card{border:1px solid #e8e8e8;padding:14px;margin-bottom:12px;}
        .dealer-mini-name{font-weight:700;font-size:14px;margin-bottom:8px;text-transform:uppercase;letter-spacing:.03em;}
        .dealer-mini-info{font-size:12px;color:#555;margin-bottom:4px;display:flex;gap:6px;align-items:flex-start;}

        /* TABS */
        .tab-bar{display:flex;gap:0;border-bottom:2px solid #e0e0e0;margin-bottom:32px;}
        .tab-btn{padding:12px 28px;font-size:13px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:#888;border-bottom:3px solid transparent;margin-bottom:-2px;transition:all .15s;}
        .tab-btn:hover{color:#1a1a1a;}
        .tab-active{color:#e8a000 !important;border-bottom-color:#e8a000;}

        /* PARTS */
        .parts-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:24px;}
        .parts-card{border:1px solid #e0e0e0;padding:28px;transition:border-color .2s;}
        .parts-card:hover{border-color:#e8a000;}
        .parts-icon{font-size:36px;margin-bottom:12px;}
        .parts-title{font-size:16px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;margin-bottom:10px;}
        .parts-desc{font-size:13px;color:#555;line-height:1.6;margin-bottom:16px;}
        .parts-list{list-style:none;display:flex;flex-direction:column;gap:6px;}
        .parts-list li{font-size:13px;color:#333;display:flex;gap:8px;align-items:center;}
        .parts-list li::before{content:"—";color:#e8a000;font-weight:700;}

        /* SERVICE */
        .service-card{border:1px solid #e0e0e0;padding:28px;transition:border-color .2s;}
        .service-card:hover{border-color:#e8a000;}

        /* WARRANTY */
        .warranty-card{border:1px solid #e0e0e0;padding:28px;transition:border-color .2s;display:flex;flex-direction:column;}
        .warranty-card:hover{border-color:#e8a000;}
        .warranty-badge{display:inline-block;background:#e8a000;color:#fff;font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;padding:4px 10px;margin-bottom:16px;}

        /* FAQ */
        .faq-item{border-bottom:1px solid #e8e8e8;}
        .faq-q{width:100%;display:flex;justify-content:space-between;align-items:center;padding:18px 0;font-size:15px;font-weight:600;color:#1a1a1a;text-align:left;gap:16px;transition:color .15s;}
        .faq-q:hover{color:#e8a000;}
        .faq-arrow{font-size:20px;color:#e8a000;flex-shrink:0;transition:transform .2s;line-height:1;}
        .faq-arrow-open{transform:rotate(90deg);}
        .faq-a{font-size:14px;color:#555;line-height:1.8;padding:0 0 20px;max-width:680px;}

        /* INFO BANNER */
        .info-banner{background:#fff8e6;border:1px solid #f5d78e;padding:18px 22px;display:flex;gap:14px;align-items:flex-start;font-size:13px;color:#555;line-height:1.7;}
        .info-banner-icon{font-size:20px;flex-shrink:0;margin-top:1px;}

        /* FOOTER */
        .footer{background:#1a1a1a;color:#ccc;}
        .footer-top{max-width:1280px;margin:0 auto;padding:48px 32px 32px;display:grid;grid-template-columns:1fr 1fr 1fr 1fr;gap:32px;border-bottom:1px solid #333;}
        .footer-col-title{font-size:11px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#fff;margin-bottom:16px;}
        .footer-col a{display:block;font-size:13px;color:#aaa;padding:5px 0;transition:color .13s;cursor:pointer;}
        .footer-col a:hover{color:#e8a000;}
        .footer-region{display:inline-flex;align-items:center;gap:8px;font-size:13px;color:#aaa;border:1px solid #444;padding:8px 14px;transition:border-color .15s;cursor:pointer;}
        .footer-region:hover{border-color:#e8a000;color:#fff;}
        .footer-bottom{background:#111;}
        .footer-bottom-inner{max-width:1280px;margin:0 auto;padding:24px 32px;display:flex;align-items:flex-start;justify-content:space-between;gap:24px;flex-wrap:wrap;}
        .footer-logos{display:flex;align-items:center;gap:24px;flex-wrap:wrap;}
        .footer-tagline-logo img{height:18px;filter:brightness(0) invert(1);opacity:.7;}
        .footer-doosan-logo img{height:32px;filter:brightness(0) invert(1);opacity:.7;}
        .social-links{display:flex;gap:12px;}
        .social-link{width:36px;height:36px;border:1px solid #444;display:flex;align-items:center;justify-content:center;transition:border-color .15s,background .15s;}
        .social-link:hover{border-color:#e8a000;background:#e8a000;}
        .social-link svg{width:16px;height:16px;fill:none;stroke:#aaa;stroke-width:2;transition:stroke .15s;}
        .social-link:hover svg{stroke:#fff;}
        .footer-legal-text{font-size:11px;color:white;line-height:1.7;max-width:700px;margin-top:12px;}
        .footer-legal-text strong{color:#999;}
        .footer-copyright{font-size:11px;color:lightgrey;margin-top:16px;}

        /* MOBILE */
        .mobile-menu{display:none;position:fixed;inset:0;z-index:2000;background:#fff;overflow-y:auto;flex-direction:column;}
        .mobile-menu.open{display:flex;}
        .mobile-menu-header{display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid #e0e0e0;background:#fff;position:sticky;top:0;z-index:10;}
        .mobile-close{font-size:24px;color:#1a1a1a;}
        .mobile-nav-item{border-bottom:1px solid #e8e8e8;}
        .mobile-nav-btn{width:100%;display:flex;justify-content:space-between;align-items:center;padding:16px 20px;font-size:14px;font-weight:700;text-transform:uppercase;letter-spacing:.06em;color:#1a1a1a;}
        .mobile-nav-sub{background:#f8f8f8;padding:8px 20px 16px;}
        .mobile-nav-sub a{display:block;font-size:13px;color:#444;padding:7px 0;border-bottom:1px solid #eee;cursor:pointer;}
        .mobile-nav-sub a:hover{color:#e8a000;}
        .mobile-util{padding:20px;display:flex;flex-direction:column;gap:10px;}
        .mobile-util a{display:block;padding:12px 16px;font-size:13px;font-weight:700;text-transform:uppercase;letter-spacing:.06em;border:2px solid #e8a000;color:#e8a000;text-align:center;cursor:pointer;}

        @media(max-width:1024px){
          .product-grid{grid-template-columns:repeat(2,1fr);}
          .footer-top{grid-template-columns:repeat(2,1fr);}
          .related-section{grid-template-columns:repeat(2,1fr);}
          .dealer-grid{grid-template-columns:repeat(2,1fr);}
          .parts-grid{grid-template-columns:1fr;}
          div[style*="grid-template-columns: repeat(3,1fr)"]{grid-template-columns:repeat(2,1fr)!important;}
        }
        @media(max-width:768px){
          .nav-links,.utility-bar{display:none;}
          .hamburger{display:flex;margin-left:auto;}
          .hero{height:260px;}
          .hero-overlay{padding:0 20px;}
          .hero-tagline{font-size:11px;}
          .product-grid{grid-template-columns:1fr;}
          .page-content{padding:20px 16px 0;}
          .related-section{grid-template-columns:1fr;padding:24px 16px;}
          .footer-top{grid-template-columns:1fr 1fr;padding:24px 16px;}
          .footer-bottom-inner{flex-direction:column;padding:16px;}
          .cta-inner{flex-direction:column;align-items:stretch;}
          .cta-strip{padding:20px 16px;}
          .dealer-grid{grid-template-columns:1fr;}
          .form-row-2{grid-template-columns:1fr;}
          .page-heading{font-size:22px;}
          .page-desc{font-size:14px;margin-bottom:24px;}
          .tab-btn{padding:10px 14px;font-size:12px;}
          .parts-grid{grid-template-columns:1fr;}
          .warranty-card{margin-bottom:16px;}
          .form-card{padding:20px 16px;}
          .quote-aside{margin-top:20px;}
          div[style*="grid-template-columns: 1fr 1fr"]{grid-template-columns:1fr!important;}
          div[style*="grid-template-columns:1fr 1fr"]{grid-template-columns:1fr!important;}
          div[style*="grid-template-columns: repeat(3,1fr)"]{grid-template-columns:1fr!important;}
          div[style*="grid-template-columns: repeat(2,1fr)"]{grid-template-columns:1fr!important;}
          div[style*="grid-template-columns: repeat(3, 1fr)"]{grid-template-columns:1fr!important;}
          div[style*="grid-template-columns: repeat(2, 1fr)"]{grid-template-columns:1fr!important;}
        }
        @media(max-width:480px){
          .footer-top{grid-template-columns:1fr;}
          .hero{height:220px;}
          .breadcrumb-inner{padding:8px 16px;}
          .cta-btn{width:100%;justify-content:center;}
          .mobile-nav-btn{font-size:13px;padding:14px 16px;}
          .faq-q{font-size:14px;}
        }
      `}</style>

      {/* UTILITY BAR */}
      <div className="utility-bar">
        <a onClick={()=>go("page-quote")}>Request a Quote</a>
        <a onClick={()=>go("page-dealer")}>Find a Dealer</a>
  
      </div>

      {/* MAIN NAV */}
      <nav className="main-nav" onMouseLeave={()=>setActiveNav(null)}>
        <div className="nav-inner">
          <div className="nav-logo" onClick={()=>go("page-diesel")}>
            <img src="./logo.png" alt="Kim Heavy Equipment" style={{width:'100px', height:'100px'}} />
          </div>
          <div className="nav-links">
            {NAV_ITEMS.map(item=>(
              <div key={item.label} className={`nav-item${activeNav===item.label?" active":""}`} onMouseEnter={()=>setActiveNav(item.label)}>
                <button>
                  {item.label}
                  <span className="nav-chevron"/>
                </button>
                {activeNav===item.label && item.mega && (
                  <div className="mega-menu">
                    {item.mega.cols.map((col,ci)=>(
                      <div key={ci} className="mega-col">
                        {col.title && <div className="mega-col-title">{col.title}</div>}
                        {col.links.map(([label,page])=>(
                          <a key={label} onClick={()=>go(page)}>{label}</a>
                        ))}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
          <button className="hamburger" onClick={()=>setMobileOpen(true)}>
            <span/><span/><span/>
          </button>
        </div>
      </nav>

      {/* MOBILE MENU */}
      <div className={`mobile-menu${mobileOpen?" open":""}`}>
        <div className="mobile-menu-header">
          <img src="/logo.png" style={{height:'80px',weight:'80px'}} />
          <button className="mobile-close" onClick={()=>setMobileOpen(false)}>✕</button>
        </div>
        {NAV_ITEMS.map(item=>(
          <div key={item.label} className="mobile-nav-item">
            <button className="mobile-nav-btn" onClick={()=>setMobileExpanded(mobileExpanded===item.label?null:item.label)}>
              {item.label} <span>{mobileExpanded===item.label?"−":"+"}</span>
            </button>
            {mobileExpanded===item.label && (
              <div className="mobile-nav-sub">
                {item.mega.cols.flatMap(col=>col.links).map(([label,page])=>(
                  <a key={label} onClick={()=>go(page)}>{label}</a>
                ))}
              </div>
            )}
          </div>
        ))}
        <div className="mobile-util">
          <a onClick={()=>go("page-quote")}>Request a Quote</a>
          <a onClick={()=>go("page-dealer")}>Find a Dealer</a>
        </div>
      </div>

      {/* PAGE CONTENT */}
      {children}

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-top">
          <div className="footer-col">
            <div className="footer-col-title">Region </div>
            <div className="footer-region">🇦🇪 Dubai, UAE (English)</div>
          </div>
          <div className="footer-col">
            <div className="footer-col-title">Equipment</div>
            {FOOTER_EQUIPMENT.map(e=><a key={e} onClick={()=>go("page-equipment")}>{e}</a>)}
          </div>
          <div className="footer-col">
            <div className="footer-col-title">Help Center</div>
            {FOOTER_HELP.map((h,i)=><a key={h} onClick={()=>go(["page-faq","page-contact","page-dealer"][i])}>{h}</a>)}
          </div>
            <div className="footer-col">
 <div className="footer-col-title">Contact Information</div>
 <h6
    style={{
      fontSize: "14px",
      fontWeight: "700",
      color: "#ffffff",
      marginBottom: "10px",
      letterSpacing: "0.5px",
      textTransform: "uppercase"
    }}
  >
   Dubai Office Address
  </h6>
<div className="footer-region">
  
 

  <p
    style={{
      fontSize: "15px",
      lineHeight: "1.8",
      color: "#d1d5db",
      margin: 0
    }}
  >
  Building 307, 1st Floor, Office No. C21
Area: Hor Al Anz, Dubai, United Arab Emirates
  </p>
</div><br/>
<h6
    style={{
      fontSize: "14px",
      fontWeight: "700",
      color: "#ffffff",
      marginBottom: "10px",
      letterSpacing: "0.5px",
      textTransform: "uppercase",
       marginTop:'10px'
    }}
  >
   Dubai Office Landline:
  </h6>
<div className="footer-region">
  
 

  <a
    style={{
      fontSize: "15px",
      lineHeight: "1.8",
      color: "#d1d5db",
      margin: 0
    }}
    href="tel: +97145688610"
  >
  +97145688610
  </a>
</div><br/>
<h6
    style={{
      fontSize: "14px",
      fontWeight: "700",
      color: "#ffffff",
      marginBottom: "10px",
      letterSpacing: "0.5px",
      textTransform: "uppercase",
       marginTop:'10px'
    }}
  >
   Comapny Phone Number:
  </h6>
<div className="footer-region">
  
 

  <a
    style={{
      fontSize: "15px",
      lineHeight: "1.8",
      color: "#d1d5db",
      margin: 0
    }}
    href="tel: 04 578 8610"
  >
 04 578 8610
  </a>
</div><br/>
<h6
    style={{
      fontSize: "12px",
      fontWeight: "700",
      color: "#ffffff",
      marginBottom: "10px",
      letterSpacing: "0.5px",
      textTransform: "uppercase",
      marginTop:'10px'
    }}
  >
   Korea's Office Address
  </h6>
<div className="footer-region">
  
 

  <p
    style={{
      fontSize: "12px",
      lineHeight: "1.8",
      color: "#d1d5db",
      margin: 0
    }}
  >
 572 Hyundaikia-ro, Namyang-eup,<br />
    Hwaseong-si, Gyeonggi-do,<br />
    Republic of Korea
<br /><br />
  </p>
</div>

<h6
    style={{
      fontSize: "12px",
      fontWeight: "700",
      color: "#ffffff",
      marginBottom: "10px",
      letterSpacing: "0.5px",
      textTransform: "uppercase",
       marginTop:'10px'
    }}
  >
   Korea's Office Mobile Number:
  </h6>
<div className="footer-region"> 

  <a
    style={{
      fontSize: "12px",
      lineHeight: "1.8",
      color: "#d1d5db",
      margin: 0
    }}
    href="tel: 01066696977"
  >
010-6669-6977
  </a>
</div><br/>




<a
  href="mailto:admin@kimheavyequipment.com"
  className="footer-contact-item"
>
  admin@kimheavyequipment.com
</a>
</div>
      
        </div>
        <div className="footer-bottom">
          <div className="footer-bottom-inner">
            <div>
              <div className="footer-logos">
                <div style={{fontSize:16,fontWeight:800,color:"#fff",letterSpacing:"0.06em",textTransform:"uppercase"}}>JINMAN KIM</div>
                <div style={{fontSize:11,color:"#e8a000",letterSpacing:"0.1em",textTransform:"uppercase"}}>Used Heavy Equipment &amp; Machinery Trading</div>
              </div>
              <p className="footer-legal-text"><strong>JINMAN KIM USED HEAVY EQUIPMENT AND MACHINERY TRADING L.L.C</strong> is a Dubai-based company specialising in the trading of used heavy equipment and machinery. Originally operating from the Republic of Korea, we are now proudly headquartered in Dubai, UAE, serving clients across the Middle East and beyond.</p>
              <p className="footer-legal-text" style={{marginTop:8}}>Website: <a href="https://www.kimheavyequipment.com" style={{color:"#e8a000"}}>kimheavyequipment.com</a> — All content and trademarks referenced on this site belong to their respective owners.</p>
              <p className="footer-copyright">©2026 JINMAN KIM USED HEAVY EQUIPMENT AND MACHINERY TRADING L.L.C. All rights reserved.</p>
            </div>
          
          </div>
        </div>
      </footer>
    </div>
  );
}

// ─── ROOT APP ─────────────────────────────────────────────────────────────────
export default function App() {
  const [page, setPage] = useState("page-diesel");

  useEffect(() => {
    emailjs.init(EMAILJS_PUBLIC_KEY);
  }, []);

  const navigate = (p) => {
    setPage(p);
    setTimeout(()=>window.scrollTo({top:0,behavior:"smooth"}),50);
  };

  const renderPage = () => {
    switch(page) {
      case "page-quote":     return <PageQuote navigate={navigate}/>;
      case "page-contact":   return <PageContact navigate={navigate}/>;
  
      case "page-parts":     return <PageParts navigate={navigate}/>;
      case "page-about":     return <PageAbout navigate={navigate}/>;
      case "page-faq":       return <PageFAQ navigate={navigate}/>;
      case "page-equipment": return <PageEquipment navigate={navigate}/>;
      default:               return <PageDiesel navigate={navigate}/>;
    }
  };

  return (
    <Layout navigate={navigate} currentPage={page}>
      {renderPage()}
    </Layout>
  );
}